import { render, staticRenderFns } from "./Xzzx.vue?vue&type=template&id=1463aa76&scoped=true&"
import script from "./Xzzx.vue?vue&type=script&lang=js&"
export * from "./Xzzx.vue?vue&type=script&lang=js&"
import style0 from "./Xzzx.vue?vue&type=style&index=0&id=1463aa76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1463aa76",
  null
  
)

export default component.exports